module.exports = "\n\n<app-navbar>\n \n</app-navbar>\n\n\n\n<router-outlet></router-outlet>\n<app-footer></app-footer>"